import { render, staticRenderFns } from "./update-modal.vue?vue&type=template&id=32f9a4ae&scoped=true"
import script from "./update-modal.vue?vue&type=script&lang=js"
export * from "./update-modal.vue?vue&type=script&lang=js"
import style0 from "./update-modal.vue?vue&type=style&index=0&id=32f9a4ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9a4ae",
  null
  
)

export default component.exports